// Prompt de instalación de la PWA. Chrome/Edge disparan beforeinstallprompt cuando la app es
// instalable; se guarda el evento y se muestra un botón propio (el navegador no deja invocarlo
// sin gesto del usuario).

import { AuthService } from "./shared/services/AuthService.js";

let promptDiferido = null;

const CLAVE_DESCARTADO = "fenix_install_descartado";

// El prompt es fixed y flota sobre el contenido: mientras está en pantalla el body reserva
// espacio abajo (ver .fx-con-install), si no tapa el último botón de la pantalla.
const quitarBoton = () => {
  document.getElementById("btnInstalarApp")?.remove();
  document.body.classList.remove("fx-con-install");
};

const crearBoton = () => {
  const boton = document.createElement("button");
  boton.type = "button";
  boton.id = "btnInstalarApp";
  boton.className = "fx-install btn btn-sm";
  boton.innerHTML = '<i class="fas fa-circle-down me-2"></i>Instalar app';

  boton.addEventListener("click", async () => {
    if (!promptDiferido) return;
    promptDiferido.prompt();
    await promptDiferido.userChoice;
    promptDiferido = null;
    quitarBoton();
  });

  const cerrar = document.createElement("span");
  cerrar.className = "fx-install__cerrar";
  cerrar.innerHTML = "&times;";
  cerrar.title = "Ahora no";
  cerrar.addEventListener("click", (e) => {
    e.stopPropagation();
    e.preventDefault();
    localStorage.setItem(CLAVE_DESCARTADO, "1");
    quitarBoton();
  });
  boton.appendChild(cerrar);

  document.body.appendChild(boton);
  document.body.classList.add("fx-con-install");
};

// Solo con sesión iniciada: sobre login/registro el botón flotante tapa los campos del formulario.
const corresponde = () =>
  !!promptDiferido && !localStorage.getItem(CLAVE_DESCARTADO) && !!AuthService.getToken();

const sincronizarBoton = () => {
  const existente = document.getElementById("btnInstalarApp");
  if (corresponde()) {
    if (!existente) crearBoton();
  } else {
    quitarBoton();
  }
};

export const registrarInstalacion = () => {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    promptDiferido = e;
    sincronizarBoton();
  });

  // El botón vive fuera de #app, así que no lo borra el innerHTML de los controllers:
  // se re-evalúa en cada cambio de pantalla.
  window.addEventListener("hashchange", sincronizarBoton);

  window.addEventListener("appinstalled", () => {
    promptDiferido = null;
    quitarBoton();
  });
};
